import destroyAdv from "../utils/destroyAdv";

export default function () {
    destroyAdv([
        'mobileBrandingSmall',
        'mobileBrandingSmallBannerWrapper'
    ]);

    if(document.getElementById('mobile-branding-inline-style') === null){
        let style = document.createElement('style');
        style.innerHTML = `
        #mobileBrandingSmallBannerWrapper {
            display: none;
        }`;
        style.id = 'mobile-branding-inline-style';
        document.head.appendChild(style);
    }
}